const NS = 'CourseCardBlock';
const CLS = 'courseCardBlock';

export class CourseCardBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$modal = this.$element.find(`.modal`);
		this.$modal.addClass(`modal--${CLS}`);
		this.$modal.appendTo('body');
		this.$buttonProgress = this.$element.find(`.${CLS}-card-footer-btn--progress`);

		// Slick event delegation fix
		$(document).on('click', `.${CLS}-card-footer-btn--progress`, (event) => {
			if($(event.currentTarget).is(this.$buttonProgress)) {
				this.$modal.modal('show');
			}
		});
	}
}
